import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import { faqs } from '@/mocks/faqs';
import { siteInfo } from '@/mocks/site';
import HeroSection from '@/pages/home/components/HeroSection';
import TrendingTicker from '@/pages/home/components/TrendingTicker';
import CategorySection from '@/pages/home/components/CategorySection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import LatestSection from '@/pages/home/components/LatestSection';
import TestimonialSection from '@/pages/home/components/TestimonialSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CtaSection from '@/pages/home/components/CtaSection';

export default function Home() {
  useSeo({
    title: '瓜田爆料 - 娱乐圈网红圈素人瓜分类合集与分区浏览',
    description:
      '瓜田爆料汇集娱乐圈、网红圈、素人瓜与行业秘闻，按分类合集整理并支持分区浏览，帮助你快速找到感兴趣的爆料类型，一站式吃瓜看料。',
    keywords: '瓜田爆料,娱乐圈,网红圈,素人瓜,行业秘闻,分类合集,分区浏览',
    canonicalPath: '/',
    ogType: 'website',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteInfo.name,
        alternateName: '瓜田爆料话题合集',
        url: 'https://yoyoermei.cn/',
        description: siteInfo.description,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://yoyoermei.cn/?keyword={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: siteInfo.name,
        url: 'https://yoyoermei.cn/',
        description: siteInfo.tagline,
        email: siteInfo.email,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <HeroSection />
      <TrendingTicker />
      <CategorySection />
      <FeaturedSection />
      <LatestSection />
      <TestimonialSection />
      <FaqSection />
      <CtaSection />
    </SiteLayout>
  );
}